import Grid from "@mui/material/Grid";
import React from "react";
import styles from "./styles";

interface Props {
  children: any;
  className?: string;
}

const FormContainer: React.FC<Props> = (props) => {
  const className = props.className
    ? `blocFormulaire ${props.className}`
    : "blocFormulaire";

  return (
    <Grid container className={className} sx={styles} columnGap={2}>
      {props.children}
    </Grid>
  );
};

export default FormContainer;
